module.exports = "/ui/bb058bd1edcde3fe1048caa059702447.jpg";